import React, { useEffect, useState } from 'react';
import Banner from '../../components/Banner/banner';
import SEO from '../../components/SEO/SEO';
import imgBanner from '../../assets/img/slider-pagina-writer.jpg';
import writerImage from '../../assets/book/Laura-Candela-8.jpg';
import { useTranslation } from 'react-i18next';
import './writer.scss';

const Writer = () => {
  const [playImages, setPlayImages] = useState([]);
  const [t] = useTranslation('global');

  useEffect(() => {
    const importAll = (r) => r.keys().map((item) => r(item));
    try {
      const images = importAll(
        require.context('../../assets/plays', false, /\.(png|jpe?g|svg)$/)
      );
      setPlayImages(images);
    } catch (err) {
      console.error('Error loading play images:', err);
    }
  }, []);

  const playsArray = [
    'Animadversion',
    'RiseToFame',
    'Namaste',
    'WelcomeToRoyonair',
    'ThreeWomen'
  ];

  return (
    <main className="globalContainer">
      <SEO title={t('WriterTitle')} canonicalPath="/screenwriter" />

      <Banner name={imgBanner} alt="Laura Candela Screenwriter" />

      <section className="globalSection" aria-label="Plays and Screenplays">
        <h1 className="sectionTitle">{t('WriterTitle')}</h1>

        <div className="playsContainer">
          {playsArray.map((playName, index) => (
            <article className="playsBox" key={playName}>
              {playImages[index] && (
                <img
                  className="playPoster"
                  src={playImages[index]}
                  alt={t(`Plays.${playName}.Title`)}
                  loading="lazy"
                />
              )}
              <div className="playsBoxText">
                <div className="playsTitle">
                  <h2 className="dataTitle">{t(`Plays.${playName}.Title`)}</h2>
                </div>
                <p className="paragraf">{t(`Plays.${playName}.Brief`)}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* Screenwriter Biography Section */}
      <section className="dataContainer brief" aria-label="Screenwriting Background">
        <div className="dataContentWrapper">
          <img
            className="dataImage"
            src={writerImage}
            alt="Laura Candela Writer Portrait"
            loading="lazy"
          />
          <article className="briefP">
            <h2 className="dataTitle">{t('WriterTitle')}</h2>
            <p className="paragraf">{t('WriterText1')}</p>
            <p className="paragraf">
              {t('WriterText2')}
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="linkText"
                href="https://www.edav.es/es/guionistes/sales-candela-laura/"
              >
                EDAV
              </a>{' '}
              {t('WriterText3')}
            </p>
          </article>
        </div>
      </section>
    </main>
  );
};

export default Writer;